import { render, staticRenderFns } from "./policyCoveredEdit.vue?vue&type=template&id=019e3f54&scoped=true"
import script from "./policyCoveredEdit.vue?vue&type=script&lang=js"
export * from "./policyCoveredEdit.vue?vue&type=script&lang=js"
import style0 from "./policyCoveredEdit.vue?vue&type=style&index=0&id=019e3f54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019e3f54",
  null
  
)

export default component.exports